/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Admin_Allocation_Form_Membership_Starts_At_HintInputs */

const en_admin_allocation_form_membership_starts_at_hint = /** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membership starts on ${i?.date}`)
};

const de_admin_allocation_form_membership_starts_at_hint = /** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mitgliedschaft beginnt am ${i?.date}`)
};

const es_admin_allocation_form_membership_starts_at_hint = /** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La suscripción comienza el ${i?.date}`)
};

const fr_admin_allocation_form_membership_starts_at_hint = /** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'abonnement commence le ${i?.date}`)
};

/** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */
const it_admin_allocation_form_membership_starts_at_hint = en_admin_allocation_form_membership_starts_at_hint;

/** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_membership_starts_at_hint = en_admin_allocation_form_membership_starts_at_hint;

/** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */
const pl_admin_allocation_form_membership_starts_at_hint = en_admin_allocation_form_membership_starts_at_hint;

/** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */
const hu_admin_allocation_form_membership_starts_at_hint = en_admin_allocation_form_membership_starts_at_hint;

/** @type {(inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs) => LocalizedString} */
const ro_admin_allocation_form_membership_starts_at_hint = en_admin_allocation_form_membership_starts_at_hint;

/**
* | output |
* | --- |
* | "Membership starts on {date}" |
*
* @param {Admin_Allocation_Form_Membership_Starts_At_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_membership_starts_at_hint = /** @type {((inputs: Admin_Allocation_Form_Membership_Starts_At_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Membership_Starts_At_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_membership_starts_at_hint(inputs)
	if (locale === "de") return de_admin_allocation_form_membership_starts_at_hint(inputs)
	if (locale === "es") return es_admin_allocation_form_membership_starts_at_hint(inputs)
	if (locale === "fr") return fr_admin_allocation_form_membership_starts_at_hint(inputs)
	if (locale === "it") return it_admin_allocation_form_membership_starts_at_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_membership_starts_at_hint(inputs)
	if (locale === "pl") return pl_admin_allocation_form_membership_starts_at_hint(inputs)
	if (locale === "hu") return hu_admin_allocation_form_membership_starts_at_hint(inputs)
	return ro_admin_allocation_form_membership_starts_at_hint(inputs)
});
export { admin_allocation_form_membership_starts_at_hint as "admin.allocation_form.membership_starts_at_hint" }